﻿import { Component, EventEmitter, Output } from "@angular/core";
import { Router} from "@angular/router";
import { DataService } from "../../services/dataService";
//import { CaptchaComponent } from "../../shared/captcha/captcha.component";
import { ValidationBase } from "../../validation/validationBase";
import { EmailValidator } from "../../validation/validators/emailValidator";
import { ValidatorTuple } from "../../validation/validators/iValidator";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";

@Component({
    selector: "jax-ExternalUserEmailVerification",
    templateUrl: "./ExternalUserEmailVerification.component.html",
})

export class ExternalUserEmailVerificationComponent extends ValidationBase {
    public captchaChallengeSucceded: boolean;
    //public captcha: CaptchaComponent;
    public validators = [];
    public iNotifyError;
    public hasSuccess: boolean = false;
    public lastName: string;
    public emailId: string;
    public actionInProgress: boolean;
    public validationMessage: ValidationMessage;
    public selected: false;

    constructor(private dataService: DataService, private router: Router) {
        super();
        this.iNotifyError = this;
        this.validators.push(new ValidatorTuple(new EmailValidator(), this));
    }

    public captchaResponse(response) {
      //  this.captchaChallengeSucceded = response;
    }

    public onClick() {
        let msg = new ValidationMessage();
        if (!this.selected) {
            msg.message="Acknowledgement of the Confidentiality statement is required to proceed";
            msg.messageType=ValidationMessageType.Error;
            this.validationMessage = msg;
            return;
         }

        if ( !this.isValid ) {
            return;
        }
     //   this.captchaChallengeSucceded = false;
        this.validationMessage = null;
        this.actionInProgress = true;
        


        this.dataService.post("extuser/verifyemail", JSON.stringify({ LastName: this.lastName , EmailAddress: this.emailId}))
            .subscribe((resp) => {
                    this.actionInProgress = false;
                    msg.message = resp.Message;
                    this.validationMessage = msg;
                    if (resp.Succeeded == 1) {
                        this.hasSuccess = true;
                        msg.messageType = ValidationMessageType.Ok;
                    } else {
                        msg.messageType = ValidationMessageType.Error;
                    }
                },
                (error) => {
                    msg.messageType = ValidationMessageType.Error;
                    msg.message = error.message;
                    this.validationMessage = msg;
                    this.hasSuccess = false;
                    this.actionInProgress = false;
                });
    }

    public login() {
        this.router.navigate(["/login"]);
    }
}
